import { DatePickerProps } from 'antd';
import { MODE, WorkCenterBaseline, TimePeriod, SHIFT } from 'models/baselines';

export type Baseline = {
  workCenter: string;
  approved: {
    from: string;
    to: string;
    periodDetails: {
      companyName: string;
      companyId: string;
      day: number;
      night: number;
    }[];
  }[];
  requested: {
    from: string;
    to: string;
    periodDetails: {
      companyName: string;
      companyId: string;
      day: number;
      night: number;
    }[];
  }[];
};

export type BaselineItemDeps = {
  id: string | null;
  workCenter: string;
  approved: TimePeriod[];
  requested: TimePeriod[];
  onIconClickHandler: (mode: MODE, workCenter: string) => void;
};

export type BaselineItemProps = {
  baseline: WorkCenterBaseline;
  isUserApprover: boolean;
  onCheckboxClickHandler: (isSelected: boolean, workCenter: string) => void;
  onIconClickHandler: (mode: MODE, workCenter: string) => void;
};

export type CompanyCollection = {
  label: string;
  value: string;
};
export type BaselineItemCompanyViewDetailsProps = {
  approvedPeriods: TimePeriod[];
  onExpandRowHandler: (index: number, isExpanded: boolean, mode: MODE) => void;
};

export type BaselineItemCompanyEditDetailsProps = {
  approvedPeriods: TimePeriod[];
  requestedPeriods: TimePeriod[];
  workCenter: string;
  companyDropdownList: CompanyCollection[];
  companyDropdownValue: string;
  addNewRange: () => void;
  onExpandRowHandler: (index: number, isExpanded: boolean, mode: MODE) => void;
  updateShift: (
    periodIndex: number,
    companyIndex: number,
    newValue: number,
    shift: SHIFT
  ) => void;
  updateDate: (
    date: DatePickerProps['onChange'],
    periodIndex: number,
    tofrom: string
  ) => void;
  onAddCompanySelectHandler: (periodIndex: number, companyId: string) => void;
};

export type BaselineItemTotalProps = {
  period?: TimePeriod;
  total?: { day: number; night: number };
};

export type BaselineItemDetailsViewProps = {
  periodIndex: number;
  period: TimePeriod;
  isExpanded: boolean;
  totalDay: number;
  totalNight: number;
  onExpandRowHandler: (index: number, isExpanded: boolean, mode: MODE) => void;
};

export type BaselineItemDetailsEditProps = {
  periodIndex: number;
  period: TimePeriod;
  isExpanded: boolean;
  totalDay: number;
  totalNight: number;
  onExpandRowHandler: (index: number, isExpanded: boolean, mode: MODE) => void;
  updateShift: (
    periodIndex: number,
    companyIndex: number,
    newValue: number,
    shift: SHIFT
  ) => void;
  updateDate: (date: any, periodIndex: number, tofrom: string) => void;
  onAddCompanySelectHandler: (periodIndex: number, companyId: string) => void;
};

export type BaselineItemDetailsEditDeps = {
  period: TimePeriod;
};

export type BaselineItemEditProps = {
  approved: TimePeriod[];
  requested: TimePeriod[];
};

export type CompanyBaselineProps = {
  periodIndex: number;
  companyIndex: number;
  companyName: string;
  night: number;
  day: number;
  onShiftUpdate: (
    periodIndex: number,
    companyIndex: number,
    newValue: number,
    shift: SHIFT
  ) => void;
};

export enum ACTION {
  APPROVE = 'approved',
  REJECT = 'rejected'
}

export type PromiseAllResponse = {
  action: ACTION;
  successResponses: number;
  failedResponses: number[];
};
